export const getErrorText = (error?: Error): string => {
  if (!error) return ''
  if (typeof error === 'string') return error
  if (error.message) return error.message
  return ''
}

export const isNewVersionError = (error?: Error) => String(error).includes('Failed to fetch dynamically imported module')
